export default "__VITE_ASSET__BQ0J9U$9__"